/*This is the application User reducer.
 *This is where the default settings for the user are stored as state
 *And updated when required.
 * @author Adam Kale @ Pufferfish Limited.
 */
import * as actionNames from "../actions/ActionTypes.js";

const initialState = {
  isAuthed: false,
  isSigningIn: false,
};
/// <summary>
//For each action type this reducer will update it's own state.
//In some cases it will call functions in other classes to pull data
//into its own state values.  This is so that any component can have access
//to any of these states but can not change them.
//Keep in mind that states should never be mutated as they are immutable.
//Always do: state = {...state, valueToUpdate: newValue}  - Never: state.valueToUpdate = newValue.
//<param name="action">the action passed from the actions.js/param>
/// </summary>
export default function UserCollection(state = initialState, action) {
  switch (action.type) {
    case actionNames.SET_IS_AUTHED:
      state = { ...state, isAuthed: action.payload };
      break;
    case actionNames.SET_IS_SIGNING_IN:
      state = { ...state, isSigningIn: action.payload };
      break;
    default:
      return state;
  }
  return state;
}
